import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const TextBoldIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="textBold" ref={ref} {...props}>
      <path d="M16.46,10.68a4.55,4.55,0,0,0,1.46-3.35,4.6,4.6,0,0,0-4.59-4.59H6.45a1.1,1.1,0,0,0-1.1,1.1V20a1.1,1.1,0,0,0,1.1,1.1h6.88a5.68,5.68,0,0,0,3.13-10.42Zm-.73-3.35a2.41,2.41,0,0,1-2.4,2.4H7.55V4.94h5.78A2.4,2.4,0,0,1,15.73,7.33ZM13.33,18.9H7.55v-7h5.78a3.49,3.49,0,0,1,0,7Z" />
    </Icon>
  ),
) as IconWithRender;

TextBoldIcon.displayName = 'TextBoldIcon';
TextBoldIcon.renderIcon = (props) => <TextBoldIcon {...props} />;
export default TextBoldIcon;
